import type { ComponentStyleConfig } from '@chakra-ui/react';

export const Tooltip: ComponentStyleConfig = {
  baseStyle: {
    fontSize: 'md',
  },
};
